import { render, staticRenderFns } from "./ExhibitionCard.vue?vue&type=template&id=2ae7b49c&scoped=true&"
import script from "./ExhibitionCard.vue?vue&type=script&lang=js&"
export * from "./ExhibitionCard.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionCard.vue?vue&type=style&index=0&id=2ae7b49c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae7b49c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
